export default __webpack_public_path__ + "static/media/fb-blue.9cb9bed2.svg";